/**
 * Voice notes are recorded on mobile (GroupChatScreen) and stored on the
 * groupMessages doc as { messageType: 'audio', audioUrl, audioDuration (seconds) }.
 */
export interface VoiceNoteFields {
  messageType?: string;
  audioUrl?: string;
  audioDuration?: number;
}

export function isVoiceNoteMessage(message: VoiceNoteFields): boolean {
  return message.messageType === 'audio' || Boolean(message.audioUrl);
}

/** m:ss, matching mobile's AudioBubble formatter. Invalid input -> 0:00. */
export function formatVoiceDuration(seconds: number | undefined | null): string {
  const total = typeof seconds === 'number' && Number.isFinite(seconds) && seconds > 0
    ? Math.round(seconds)
    : 0;
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}
